<template>
  <el-drawer
    v-loading="loading"
    :title="title?title:form.id ? '编辑合同信息' : '新增合同信息'"
    :visible.sync="show"
    size="80%"
    :before-close="handleClose"
    append-to-body
    destroy-on-close
    center
    :close-on-click-modal="false"
  >
    <div style="height: calc(100vh - 110px); overflow-y: auto">
      <el-form ref="form" :disabled="type == '查看'" :model="form" :rules="rules" label-width="100px">
        <el-card header="基础信息">
          <el-row>
            <el-col :span="5">
              <el-form-item label="合同编码" prop="sn">
                <el-input v-model="form.sn" disabled placeholder="自动生成" clearable />
              </el-form-item>
            </el-col>

            <el-col :span="5">
              <el-form-item label="合同号" prop="contractSn">
                <el-input v-model="form.contractSn" placeholder="请输入合同号" clearable disabled />
              </el-form-item>
            </el-col>

            <el-col :span="5">
              <el-form-item label="合同名称" prop="contractName">
                <el-input
                  v-model="form.contractName"
                  placeholder="请输入合同名称"
                  clearable
                  :disabled="
                    [2, 3].includes(form.status) &&
                      !(flowOptions.isAssignee && flowOptions.nodeName == '开始')
                  "
                />
              </el-form-item>
            </el-col>

            <el-col :span="5">
              <el-form-item label="业务员" prop="salesman">
                <!-- <el-input
                v-model="form.salesman"
                placeholder="请输入业务员"
                :disabled="
                  [2, 3].includes(form.status) &&
                  !(flowOptions.isAssignee && flowOptions.nodeName == '开始')
                "
                clearable
              /> -->
                <el-select
                  v-model="form.salesman"
                  placeholder="请选择业务员"
                  clearable
                  :disabled="
                    [2, 3].includes(form.status) &&
                      !(flowOptions.isAssignee && flowOptions.nodeName == '开始')
                  "
                >
                  <el-option
                    v-for="item in salesmanOptions"
                    :key="item.adminId"
                    :label="item.userName"
                    :value="item.userName"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5">
              <el-form-item label="客户编码" prop="customerNo">
                <el-input
                  v-model="form.customerNo"
                  placeholder="请输入客户编码"
                  clearable
                  readonly
                  :disabled="
                    [2, 3].includes(form.status) &&
                      !(flowOptions.isAssignee && flowOptions.nodeName == '开始')
                  "
                >
                  <el-button
                    slot="append"
                    :disabled="
                      [2, 3].includes(form.status) &&
                        !(flowOptions.isAssignee && flowOptions.nodeName == '开始')
                    "
                    icon="el-icon-search"
                    @click="onPicker"
                  />
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :span="5">
              <el-form-item label="客户名称" prop="customerName">
                <el-input v-model="form.customerName" disabled clearable />
              </el-form-item>
            </el-col>

            <el-col :span="5">
              <el-form-item label="客户地区" prop="customerAreaId">
                <area-select v-model="form.customerAreaId" disabled @change="handleAreaSelect" />
              </el-form-item>
            </el-col>

            <el-col :span="5">
              <el-form-item label="详细地址" prop="customerAddress">
                <el-input v-model="form.customerAddress" disabled clearable />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5">
              <el-form-item label="联系人" prop="contact">
                <el-input
                  v-model="form.contact"
                  placeholder="请输入联系人"
                  clearable
                  :disabled="
                    [2, 3].includes(form.status) &&
                      !(flowOptions.isAssignee && flowOptions.nodeName == '开始')
                  "
                />
              </el-form-item>
            </el-col>

            <el-col :span="5">
              <el-form-item label="联系人电话" prop="contactMobile">
                <el-input
                  v-model="form.contactMobile"
                  placeholder="请输入联系人电话"
                  clearable
                  :disabled="
                    [2, 3].includes(form.status) &&
                      !(flowOptions.isAssignee && flowOptions.nodeName == '开始')
                  "
                />
              </el-form-item>
            </el-col>

            <el-col :span="5">
              <el-form-item label="总金额" prop="totalMoney">
                <el-input v-model="form.totalMoney" disabled clearable />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="流程状态" prop="status">
                <el-select v-model="form.status" clearable filterable disabled>
                  <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5">
              <el-form-item label="是否开票" prop="isInvoice">
                <el-select
                  v-model="form.isInvoice"
                  clearable
                  placeholder="是否开票"
                  :disabled="
                    [2, 3].includes(form.status) &&
                      !(flowOptions.isAssignee && flowOptions.nodeName == '开始')
                  "
                >
                  <el-option :value="1" label="是" />
                  <el-option :value="0" label="否" />
                </el-select>

                <!-- <el-input
                v-model="form.isInvoice"
                placeholder="请输入是否开票 0.否 1.是"
                clearable
              /> -->
              </el-form-item>
              <!--               <el-table-column-->
              <!--                 label="是否开票"-->
              <!--                 align="left"-->
              <!--                 prop="isInvoice"-->
              <!--                 show-overflow-tooltip-->
              <!--               >-->
              <!--                 <template #default="{ row }">-->
              <!--                   {{ getState(isxzs, row.isInvoice) }}-->
              <!--                 </template>-->
              <!--               </el-table-column>-->
            </el-col>

            <el-col :span="5">
              <el-form-item
                label="是否收款"
                prop="isProceeds"
                :rules="[
                  {
                    required:
                      flowOptions.isAssignee &&
                      [2].includes(form.status) &&
                      flowOptions.nodeName == '财务',
                    message: '请选择是否收款',
                    trigger: 'blur',
                  },
                ]"
              >
                <!-- <el-input
                v-model="form.isProceeds"
                placeholder="请输入是否收款 0.否 1.是"
                clearable
              /> -->
                <el-select
                  v-model="form.isProceeds"
                  clearable
                  placeholder=""
                  :disabled="
                    !flowOptions.isAssignee ||
                      ![2].includes(form.status) ||
                      flowOptions.nodeName != '财务'
                  "
                >
                  <el-option :value="1" label="是" />
                  <el-option :value="0" label="否" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="是否加急">
                <el-checkbox
                  v-model="form.isUrgent"
                  :true-label="1"
                  :false-label="0"
                  :disabled="
                    [2, 3].includes(form.status) &&
                      !(flowOptions.isAssignee && flowOptions.nodeName == '开始')
                  "
                />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="备注" prop="note">
                <el-input
                  v-model="form.note"
                  placeholder="请输入备注"
                  clearable
                  :disabled="
                    [2, 3].includes(form.status) &&
                      !(flowOptions.isAssignee && flowOptions.nodeName == '开始')
                  "
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
        <el-card header="合同明细">
          <div slot="header" class="clearfix">
            <span>合同明细</span>
            <el-button
              style="float: right; padding: 3px 0"
              type="text"
              :disabled="
                [2, 3].includes(form.status) &&
                  !(flowOptions.isAssignee && flowOptions.nodeName == '开始')
              "
              @click="onAdd"
            >新增</el-button>
          </div>
          <el-row>
            <el-table
              ref="elTable"
              :data="form.hcContractLineModels"
              border
              stripe
              :summary-method="getSummaries"
              show-summary
              :height="280"
            >

              <el-table-column min-width="200" label="项目类型" align="left" prop="projectType" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-form-item
                    :prop="
                      'hcContractLineModels.' + scope.$index + '.projectType'
                    "
                    :rules="[
                      {
                        required: true,
                        message: '请填写项目类型',
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-select
                      v-model="scope.row.projectType"
                      clearable
                      filterable
                      :disabled="
                        [2, 3].includes(form.status) &&
                          !(
                            flowOptions.isAssignee && flowOptions.nodeName == '开始'
                          )
                      "
                    >
                      <el-option
                        v-for="item in productCategoryOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column min-width="200" label="产品名称" align="left" prop="productCategory" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-form-item
                    :prop="
                      'hcContractLineModels.' + scope.$index + '.productCategory'
                    "
                    :rules="[
                      {
                        required: true,
                        message: '请填写产品名称',
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input
                      v-model="scope.row.productCategory"
                      placeholder=""
                      clearable
                      :disabled="
                        [2, 3].includes(form.status) &&
                          !(
                            flowOptions.isAssignee && flowOptions.nodeName == '开始'
                          )
                      "
                    />
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column min-width="200" label="产品型号" align="left" prop="model" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-form-item
                    :prop="
                      'hcContractLineModels.' + scope.$index + '.model'
                    "
                  >
                    <el-input
                      v-model="scope.row.model"
                      placeholder=""
                      clearable
                      :disabled="
                        [2, 3].includes(form.status) &&
                          !(
                            flowOptions.isAssignee && flowOptions.nodeName == '开始'
                          )
                      "
                    />
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column min-width="200" label="证书编号" align="left" prop="certificateNumber" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-form-item
                    :prop="
                      'hcContractLineModels.' + scope.$index + '.certificateNumber'
                    "
                  >
                    <el-input
                      v-model="scope.row.certificateNumber"
                      placeholder=""
                      clearable
                      :disabled="
                        [2, 3].includes(form.status) &&
                          !(
                            flowOptions.isAssignee && flowOptions.nodeName == '开始'
                          )
                      "
                    />
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column min-width="200" label="发证机构" align="left" prop="certifyingAuthority" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-form-item
                    :prop="
                      'hcContractLineModels.' + scope.$index + '.certifyingAuthority'
                    "
                  >
                    <el-input
                      v-model="scope.row.certifyingAuthority"
                      placeholder=""
                      clearable
                      :disabled="
                        [2, 3].includes(form.status) &&
                          !(
                            flowOptions.isAssignee && flowOptions.nodeName == '开始'
                          )
                      "
                    />
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column min-width="200" label="是否审厂" align="left" prop="isFactory" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-form-item
                    :prop="
                      'hcContractLineModels.' + scope.$index + '.isFactory'
                    "
                  >
                    <el-checkbox
                      v-model="scope.row.isFactory"
                      :true-label="1"
                      :false-label="0"
                      :disabled="
                        [2, 3].includes(form.status) &&
                          !(
                            flowOptions.isAssignee && flowOptions.nodeName == '开始'
                          )
                      "
                    />
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column min-width="200" label="项目单价" align="left" show-overflow-tooltip prop="projectPrice">
                <template slot-scope="scope">
                  <el-form-item
                    :prop="
                      'hcContractLineModels.' + scope.$index + '.projectPrice'
                    "
                    :rules="[
                      {
                        required: true,
                        message: '请填写项目单价',
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input
                      v-model="scope.row.projectPrice"
                      placeholder=""
                      clearable
                      :disabled="
                        [2, 3].includes(form.status) &&
                          !(
                            flowOptions.isAssignee && flowOptions.nodeName == '开始'
                          )
                      "
                      @input="scope.row.projectPrice = scope.row.projectPrice.replace(/[^-?\d*\.?\d*$]/g, '')"
                    />
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column min-width="200" prop="projectSn" label="项目号" align="left" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-form-item :prop="'hcContractLineModels.' + scope.$index + '.projectSn'">
                    <el-input v-model="scope.row.projectSn" placeholder="" clearable disabled />
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column
                min-width="200"
                label="要求完成工作日"
                align="left"
                show-overflow-tooltip
                prop="askAccomplishTime"
              >
                <template slot-scope="scope">
                  <el-form-item
                    :prop="
                      'hcContractLineModels.' +
                        scope.$index +
                        '.askAccomplishTime'
                    "
                    :rules="[
                      {
                        required: true,
                        message: '请填写要求完成工作日',
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-date-picker
                      v-model="scope.row.askAccomplishTime"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期"
                      clearable
                      :disabled="
                        [2, 3].includes(form.status) &&
                          !(
                            flowOptions.isAssignee && flowOptions.nodeName == '开始'
                          )
                      "
                    />
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column min-width="200" prop="laboratory" label="实验室" align="left" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-form-item
                    :prop="'hcContractLineModels.' + scope.$index + '.laboratory'"
                    :rules="[
                      {
                        required:
                          flowOptions.isAssignee &&
                          [2].includes(form.status) &&
                          flowOptions.nodeName == '总经理',
                        message: '请填写实验室',
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input
                      v-model="scope.row.laboratory"
                      placeholder=""
                      clearable
                      :disabled="
                        !flowOptions.isAssignee ||
                          ![2].includes(form.status) ||
                          flowOptions.nodeName != '总经理'
                      "
                    />
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column min-width="200" prop="merchandiser" label="跟单员" align="left" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-form-item
                    :prop="
                      'hcContractLineModels.' + scope.$index + '.merchandiser'
                    "
                    :rules="[
                      {
                        required:
                          flowOptions.isAssignee &&
                          [2].includes(form.status) &&
                          flowOptions.nodeName == '总经理',
                        message: '请填写跟单员',
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <!-- <el-input
                    v-model="scope.row.merchandiser"
                    placeholder=""
                    clearable
                    :disabled="
                      !flowOptions.isAssignee ||
                      ![2].includes(form.status) ||
                      flowOptions.nodeName != '总经理'
                    "
                  /> -->

                    <el-select
                      v-model="scope.row.merchandiser"
                      placeholder="请选择"
                      clearable
                      :disabled="
                        !flowOptions.isAssignee ||
                          ![2].includes(form.status) ||
                          flowOptions.nodeName != '总经理'
                      "
                    >
                      <el-option
                        v-for="item in merchandiserOptions"
                        :key="item.adminId"
                        :label="item.userName"
                        :value="item.userName"
                      />
                    </el-select>
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column min-width="200" label="培训工程师" align="left" show-overflow-tooltip prop="cultivateEngineer">
                <template slot-scope="scope">
                  <el-form-item
                    :prop="
                      'hcContractLineModels.' +
                        scope.$index +
                        '.cultivateEngineer'
                    "
                    :rules="[
                      {
                        required:
                          flowOptions.isAssignee &&
                          [2].includes(form.status) &&
                          flowOptions.nodeName == '总经理',
                        message: '请填写培训工程师',
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <!-- <el-input
                    v-model="scope.row.cultivateEngineer"
                    placeholder=""
                    clearable
                    :disabled="
                      !flowOptions.isAssignee ||
                      ![2].includes(form.status) ||
                      flowOptions.nodeName != '总经理'
                    "
                  /> -->

                    <el-select
                      v-model="scope.row.cultivateEngineer"
                      placeholder="请选择培训工程师"
                      clearable
                      :disabled="
                        !flowOptions.isAssignee ||
                          ![2].includes(form.status) ||
                          flowOptions.nodeName != '总经理'
                      "
                    >
                      <el-option
                        v-for="item in cultivateEngineerOptions"
                        :key="item.adminId"
                        :label="item.userName"
                        :value="item.userName"
                      />
                    </el-select>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column min-width="200" prop="note" label="说明" align="left" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-form-item :prop="'hcContractLineModels.' + scope.$index + '.note'">
                    <el-input
                      v-model="scope.row.note"
                      placeholder=""
                      clearable
                      :disabled="
                        [2, 3].includes(form.status) &&
                          !(
                            flowOptions.isAssignee && flowOptions.nodeName == '开始'
                          )
                      "
                    />
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column min-width="200" label="操作" fixed="right" width="100">
                <template slot-scope="scope">
                  <el-button
                    :disabled="
                      [2, 3].includes(form.status) &&
                        !(flowOptions.isAssignee && flowOptions.nodeName == '开始')
                    "
                    type="text"
                    @click="handleDelete(scope.$index)"
                  >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-card>
        <el-card header="开票信息">
          <el-row>
            <el-col :span="5">
              <el-form-item label="注册地址" prop="registerAddress">
                <el-input v-model="form.registerAddress" disabled clearable />
              </el-form-item>
            </el-col>

            <el-col :span="5">
              <el-form-item label="办公地址" prop="workAddress">
                <el-input v-model="form.workAddress" disabled clearable />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="纳税人识别号" prop="taxpayerCode">
                <el-input v-model="form.taxpayerCode" disabled clearable />
              </el-form-item>
            </el-col>

            <el-col :span="5">
              <el-form-item label="发票抬头" prop="invoiceTitle">
                <el-input v-model="form.invoiceTitle" disabled clearable />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5">
              <el-form-item label="开户银行" prop="invoicingDepositBank">
                <el-input v-model="form.invoicingDepositBank" disabled clearable />
              </el-form-item>
            </el-col>

            <el-col :span="5">
              <el-form-item label="银行账号" prop="invoicingBankNumber">
                <el-input v-model="form.invoicingBankNumber" disabled clearable />
              </el-form-item>
            </el-col>

            <el-col :span="5">
              <el-form-item label="公司电话" prop="invoicingCompanyPhone">
                <el-input v-model="form.invoicingCompanyPhone" disabled clearable />
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
        <el-card header="收款信息">
          <div slot="header" class="clearfix">
            <span>收款信息</span>
            <el-button
              style="float: right; padding: 3px 0"
              type="text"
              :disabled="
                [2, 3].includes(form.status) &&
                  !(flowOptions.isAssignee && flowOptions.nodeName == '开始')
              "
              @click="onAdd2"
            >新增</el-button>
          </div>
          <el-row>
            <el-table :data="form.hcContractProceedsLineModels" border stripe :height="280">
              <el-table-column label="收款节点" align="left" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-form-item
                    :prop="
                      'hcContractProceedsLineModels.' +
                        scope.$index +
                        '.proceedsNode'
                    "
                  >
                    <el-input
                      v-model="scope.row.proceedsNode"
                      placeholder=""
                      clearable
                      :disabled="
                        [2, 3].includes(form.status) &&
                          !(
                            flowOptions.isAssignee && flowOptions.nodeName == '开始'
                          )
                      "
                    />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="收款方式" align="left" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-form-item
                    :prop="
                      'hcContractProceedsLineModels.' +
                        scope.$index +
                        '.paymentTerm'
                    "
                  >
                    <el-input
                      v-model="scope.row.paymentTerm"
                      placeholder=""
                      clearable
                      :disabled="
                        [2, 3].includes(form.status) &&
                          !(
                            flowOptions.isAssignee && flowOptions.nodeName == '开始'
                          )
                      "
                    />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="收款比例" align="left" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-form-item
                    :prop="
                      'hcContractProceedsLineModels.' + scope.$index + '.ratio'
                    "
                  >
                    <el-input
                      v-model="scope.row.ratio"
                      placeholder=""
                      clearable
                      :disabled="
                        [2, 3].includes(form.status) &&
                          !(
                            flowOptions.isAssignee && flowOptions.nodeName == '开始'
                          )
                      "
                    />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="金额" align="left" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-form-item
                    :prop="
                      'hcContractProceedsLineModels.' + scope.$index + '.price'
                    "
                  >
                    <el-input
                      v-model="scope.row.price"
                      placeholder=""
                      clearable
                      :disabled="
                        [2, 3].includes(form.status) &&
                          !(
                            flowOptions.isAssignee && flowOptions.nodeName == '开始'
                          )
                      "
                      @input="scope.row.price = scope.row.price.replace(/[^-?\d*\.?\d*$]/g, '')"
                    />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="说明" align="left" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-form-item
                    :prop="
                      'hcContractProceedsLineModels.' + scope.$index + '.note'
                    "
                  >
                    <el-input
                      v-model="scope.row.note"
                      placeholder=""
                      clearable
                      :disabled="
                        [2, 3].includes(form.status) &&
                          !(
                            flowOptions.isAssignee && flowOptions.nodeName == '开始'
                          )
                      "
                    />
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column label="操作" fixed="right" width="200">
                <template slot-scope="scope">
                  <el-button
                    :disabled="
                      [2, 3].includes(form.status) &&
                        !(flowOptions.isAssignee && flowOptions.nodeName == '开始')
                    "
                    type="text"
                    @click="handleDelete2(scope.$index)"
                  >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-card>

        <el-card header="附件">
          <el-upload
            class="upload-demo"
            :action="uploadUrl"
            :disabled="
              [2, 3].includes(form.status) &&
                !(flowOptions.isAssignee && flowOptions.nodeName == '开始')
            "
            :on-remove="handleRemove"
            :on-success="handleAvatarSuccess"
            multiple
            :on-preview="handlePreview"
            :file-list="form.hcContractAccessoryModels"
          >
            <el-button
              :disabled="
                [2, 3].includes(form.status) &&
                  !(flowOptions.isAssignee && flowOptions.nodeName == '开始')
              "
              size="small"
              type="primary"
            >点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              <!-- 只能上传jpg/png文件，且不超过500kb -->
            </div>
          </el-upload>
        </el-card>
        <el-card header="流程审批">
          <flow
            ref="flow"
            :custom-event="true"
            :flow-id="form.flowId"
            @flowLoad="flowLoad"
            @complete="onComplete"
            @stop="getData"
          />
        </el-card>
        <el-form-item>
          <el-button :disabled="[3].includes(form.status)" type="primary" @click="submitForm('form')">确认</el-button>
          <el-button
            v-if="form.id && (form.status == 1 || !form.status)"
            :disabled="
              [2, 3].includes(form.status) &&
                !(flowOptions.isAssignee && flowOptions.nodeName == '开始')
            "
            type="primary"
            @click="submit()"
          >提交</el-button>
          <el-button @click="handleClose">取消</el-button>
        </el-form-item>
      </el-form>
      <customerDialog ref="customerDialog" @select="onSelect" />
    </div>
  </el-drawer>
</template>

<script>
import {
  get,
  saveOrUpdate,
  submit,
  getSelectMerchandiser,
  getSalesmanOptions,
  getCultivateEngineerOptions
} from '@/api/hc/contract/contract'
import Flow from '@/components/Flow'
import customerDialog from '@/views/hc/components/customerDialog'
import { saveAs } from 'file-saver'
import AreaSelect from '@/views/fwpt/basic/area/AreaSelect'
export default {
  name: 'hcContractEdit',
  components: { Flow, customerDialog, AreaSelect },
  props: {
    show: {
      type: Boolean,
      default() {
        return false
      }
    },
    editId: Number
  },

  data() {
    return {
      title: '',
      merchandiserOptions: [], // 跟单员
      salesmanOptions: [],
      cultivateEngineerOptions: [],
      type: '',
      flowOptions: {},
      uploadUrl: process.env.VUE_APP_FILE_UPLOAD_URL,
      statusOptions: [
        {
          label: '制单',
          value: 1
        },
        {
          label: '审核中',
          value: 2
        },
        {
          label: '审核完成',
          value: 3
        },
        {
          label: '驳回',
          value: 4
        }
      ],
      isxzs: [
        {
          code: '0',
          name: '否'
        },
        {
          code: '1',
          name: '是'
        }
      ],
      loading: false,
      productCategoryOptions: [
        {
          label: 'CCC新申请',
          value: 1
        },
        {
          label: 'CCCS同类新申请',
          value: 2
        },
        {
          label: '能效检测',
          value: 3
        },
        {
          label: '委托测试项目',
          value: 4
        },
        {
          label: '化学项目',
          value: 5
        },
        {
          label: '体系项目',
          value: 6
        },
        {
          label: '节能认证新申请',
          value: 7
        },
        {
          label: '节能认证同类新申请',
          value: 8
        },
        {
          label: '环保认证',
          value: 9
        },
        {
          label: '环保认证同类新申请',
          value: 10
        },
        {
          label: 'CB认证',
          value: 11
        },
        {
          label: 'CE认证',
          value: 12
        }
      ],
      projectTypeOptions: [
        {
          label: 'CCCS同类新申请',
          value: 1
        },
        {
          label: '能效检测',
          value: 2
        },
        {
          label: '委托测试项目',
          value: 3
        },
        {
          label: '化学项目',
          value: 4
        },
        {
          label: '节能认证同类新申请',
          value: 5
        },
        {
          label: '环保认证同类新申请',
          value: 6
        },
        {
          label: 'CB认证',
          value: 7
        },
        {
          label: 'CE认证',
          value: 8
        }
      ],
      form: {
        hcContractLineModels: [],
        hcContractProceedsLineModels: [],
        hcContractAccessoryModels: [],
        id: null,
        sn: null,
        contractSn: null,
        contractName: null,
        salesman: null,
        customerId: null,
        customerNo: null,
        customerName: null,
        customerAreaId: null,
        customerAddress: null,
        contact: null,
        contactMobile: null,
        totalMoney: null,
        isInvoice: null,
        isProceeds: null,
        registerAddress: null,
        workAddress: null,
        taxpayerCode: null,
        invoiceTitle: null,
        invoicingDepositBank: null,
        invoicingBankNumber: null,
        invoicingCompanyPhone: null,
        note: null,
        status: null,
        flowId: null,
        flowTitle: null,
        flowUrgent: null,
        billNo: null,
        flowTaskFId: null
      },
      rules: {
        // contractSn: [
        //   {
        //     required: true,
        //     message: '合同号不能为空',
        //     trigger: ['blur', 'change']
        //   }
        // ],
        contractName: [
          {
            required: true,
            message: '合同名称不能为空',
            trigger: ['blur', 'change']
          }
        ],
        salesman: [
          {
            required: true,
            message: '业务员不能为空',
            trigger: ['blur', 'change']
          }
        ],
        // customerId: [{ required: true, message: '客户id不能为空', trigger: 'blur' }],
        customerNo: [
          {
            required: true,
            message: '客户编码不能为空',
            trigger: ['blur', 'change']
          }
        ],
        // customerName: [{ required: true, message: '客户名称不能为空', trigger: 'blur' }],
        // customerAreaId: [{ required: true, message: '地区id不能为空', trigger: 'blur' }],
        // customerAddress: [{ required: true, message: '详细地址不能为空', trigger: 'blur' }],
        contact: [
          {
            required: true,
            message: '联系人不能为空',
            trigger: ['blur', 'change']
          }
        ],
        contactMobile: [
          {
            required: true,
            message: '联系人电话不能为空',
            trigger: ['blur', 'change']
          }
        ],
        // totalMoney: [{ required: true, message: '总金额不能为空', trigger: 'blur' }],
        isInvoice: [
          {
            required: true,
            message: '是否开票不能为空',
            trigger: ['blur', 'change']
          }
        ]
        // isProceeds: [
        //   {
        //     required: true,
        //     message: "是否收款 0.否 1.是不能为空",
        //      trigger: ['blur', 'change'],
        //   },
        // ],
        // registerAddress: [{ required: true, message: '注册地址不能为空', trigger: 'blur' }],
        // workAddress: [{ required: true, message: '办公地址不能为空', trigger: 'blur' }],
        // taxpayerCode: [{ required: true, message: '纳税人识别号不能为空', trigger: 'blur' }],
        // invoiceTitle: [{ required: true, message: '发票抬头不能为空', trigger: 'blur' }],
        // invoicingDepositBank: [{ required: true, message: '开户银行不能为空', trigger: 'blur' }],
        // invoicingBankNumber: [{ required: true, message: '银行账号不能为空', trigger: 'blur' }],
        // invoicingCompanyPhone: [{ required: true, message: '公司电话不能为空', trigger: 'blur' }],
        // note: [{ required: true, message: '备注不能为空', trigger: 'blur' }],
        // status: [
        //   { required: true, message: "流程状态不能为空",  trigger: ['blur', 'change'] },
        // ],
        // flowId: [
        //   { required: true, message: "流程主键不能为空",  trigger: ['blur', 'change'] },
        // ],
        // flowTitle: [
        //   { required: true, message: "流程标题不能为空",  trigger: ['blur', 'change'] },
        // ],
        // flowUrgent: [
        //   { required: true, message: "紧急程度不能为空",  trigger: ['blur', 'change'] },
        // ],
        // billNo: [
        //   { required: true, message: "单据编号不能为空",  trigger: ['blur', 'change'] },
        // ],
        // flowTaskFId: [
        //   { required: true, message: "流程任务主键不能为空",  trigger: ['blur', 'change'] },
        // ],
      }
    }
  },
  watch: {
    // "form.isProceeds": {
    //   handler: function (newValue, oldValue) {
    //     console.log(newValue);
    //     if (newValue !== 0 || newValue !== 1) {
    //       this.$refs.flow.validator = () => {
    //         this.$message({
    //           type:'warning',
    //           message: ''
    //         })
    //       };
    //     } else {
    //       this.$refs.flow.validator = null;
    //     }
    //   },
    //   deep: true,
    //   immediate: true,
    // },
    editId(editId) { },
    show(show) {
      if (!show) {
        return
      }
      this.type = this.$route.query.type
      getSelectMerchandiser().then((res) => {
        this.merchandiserOptions = res.data.records || []
      })

      getSalesmanOptions().then((res) => {
        this.salesmanOptions = res.data.records || []
      })
      getCultivateEngineerOptions().then((res) => {
        this.cultivateEngineerOptions = res.data.records || []
      })
      if (this.editId == null) {
        this.form = this.$options.data.call(this).form
        return
      }
      this.loading = true
      this.getData()
    }
  },
  methods: {
    async getData() {
      if (!this.editId) return
      this.loading = true
      try {
        const response = await get(this.editId)
        const { data } = response
        this.form = data
        this.loading = false
        if (!Array.isArray(this.form.hcContractLineModels)) {
          this.form.hcContractLineModels = []
        }

        if (!Array.isArray(this.form.hcContractProceedsLineModels)) {
          this.form.hcContractProceedsLineModels = []
        }

        if (Array.isArray(this.form.hcContractAccessoryModels)) {
          this.form.hcContractAccessoryModels.forEach((item) => {
            this.$set(item, 'url', item.accessoryUrl)
            this.$set(item, 'name', item.accessoryName)
          })
        } else {
          this.form.hcContractAccessoryModels = []
        }
        this.$nextTick(() => {
          this.$refs.elTable.doLayout()
        })
      } catch (error) {
        this.loading = false
      }
    },
    // 流程提交
    async onComplete() {
      // 先执行保存
      await this.submitForm('form', false, async() => {
        // await this.getData();
        // 在执行提交
        this.$refs.flow.onComplete(() => {
          this.handleClose()
        })
      })
    },
    async download(url, fileName) {
      try {
        const response = await fetch(url)
        const blob = await response.blob()
        const objectUrl = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = objectUrl
        a.download = fileName
        a.click()
        a.remove()
      } catch (error) {
        console.log(error, '66666')
      }
    },
    flowLoad(e) {
      console.log(e)
      this.flowOptions = e
      this.$refs.flow.validatorForm.push(this.$refs.isProceeds)
    },
    handlePreview(file) {
      // if(this.flowOptions.nodeName != '总经理') return;
      window.open(file.url, file.url, '_blank')
      // this.download(file.url, file.accessoryName || file.url);
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
      this.form.hcContractAccessoryModels = fileList
    },
    handleAvatarSuccess(response) {
      if (!response.status === 200) {
        this.$message.error(response.msg)
        return
      }
      const { fileName, url, md5 } = response.data
      this.form.hcContractAccessoryModels.push({
        // contractApplyId: 1 /** 合同主表ID */,
        accessoryName: fileName,
        accessoryUrl: url /** 附件URL */,
        url: url /** 附件URL */,
        name: fileName /** 附件URL */
      })
      console.log(fileName, url, md5)
    },
    onAdd2() {
      this.form.hcContractProceedsLineModels.push({
        proceedsNode: undefined, // 收款节点
        paymentTerm: undefined, // 收款方式
        ratio: undefined, // 收款比例
        price: undefined, // 金额
        note: undefined // 说明
      })
    },
    handleDelete2(index) {
      this.form.hcContractProceedsLineModels.splice(index, 1)
    },
    handleDelete(index) {
      this.form.hcContractLineModels.splice(index, 1)
    },
    onAdd() {
      this.form.hcContractLineModels.push({
        id: undefined,
        createTime: undefined,
        updateTime: undefined,
        createUser: undefined,
        updateUser: undefined,
        tenantCode: undefined,
        deleteFlag: undefined,
        version: undefined,
        contractLineId: undefined,
        contractApplyChangeId: undefined,
        contractApplyId: undefined,
        productCategory: undefined,
        projectType: undefined,
        projectPrice: undefined,
        projectSn: undefined,
        askAccomplishTime: undefined,
        laboratory: undefined,
        merchandiser: undefined,
        cultivateEngineer: undefined,
        note: undefined
      })
    },
    onPicker() {
      this.$refs.customerDialog.open()
    },
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总价'
          return
        }
        const values = data.map((item) => {
          console.log(item[column.property])
          return Number(item[column.property])
        })
        console.log(data)
        console.log(values)
        if (
          !values.every((value) => isNaN(value)) &&
          ['projectPrice'].includes(column.property)
        ) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          this.form.totalMoney = sums[index]
        } else {
          sums[index] = ''
        }
      })

      return sums
    },
    onSelect(row) {
      console.log(row, '520')
      Object.assign(this.form, {
        customerId: row.id,
        customerNo: row.customerNo,
        customerName: row.customerName,
        customerAreaId: row.customerAreaId,
        customerAddress: row.customerAddress,

        contact: row.customerContacts,
        contactMobile: row.customerPhone,

        isInvoice: row.isInvoice,

        registerAddress: row.invoicingRegisterAddress, // 注册地址
        workAddress: row.invoicingCompanyAddress, // 办公地址
        taxpayerCode: row.invoicingCompanyNumber, // 纳税人识别号
        invoiceTitle: row.invoiceTitle,
        invoicingDepositBank: row.invoicingDepositBank, // 开户行名称
        invoicingBankNumber: row.invoicingBankNumber, // 银行账号
        invoicingCompanyPhone: row.invoicingCompanyPhone // 办公电话
      })
    },
    getState(data, code) {
      const row = data.find((item) => item.code == code)
      if (row) {
        return row.name
      } else {
        return ''
      }
    },
    isActive(route) {
      return route.path === this.$route.path
    },
    toLastView(visitedViews, view) {
      const latestView = visitedViews.slice(-1)[0]
      if (latestView) {
        this.$router.push(latestView.fullPath)
      } else {
        // now the default is to redirect to the home page if there is no tags-view,
        // you can adjust it according to your needs.
        if (view.name === 'Dashboard') {
          // to reload home page
          this.$router.replace({ path: '/redirect' + view.fullPath })
        } else {
          this.$router.push('/')
        }
      }
    },
    handleClose() {
      Object.assign(this.$data, this.$options.data.call(this))
      // const view = this.$route
      // this.$store
      //   .dispatch('tagsView/delView', view)
      //   .then(({ visitedViews }) => {
      //     if (this.isActive(view)) {
      //       this.toLastView(visitedViews, view)
      //     }
      //   })
      this.$emit('close')
    },
    async submitForm(formName, isClose = false, cb) {
      this.$refs[formName].validate(async(valid, obj) => {
        if (valid) {
          // ---- 需要手工填写此代码 -----
          // 判断是否添加合同明细
          if (this.form.hcContractLineModels.length == 0) {
            this.$message({
              type: 'warning',
              message: '请添加合同明细'
            })
            return
          }
          try {
            this.loading = true
            const { message } = await saveOrUpdate(this.form)
            this.$message({
              type: 'success',
              message: message
            })
            await this.getData()
            console.log('33333')
            this.loading = false
            if (cb) {
              await cb()
            }
            if (isClose) {
              this.handleClose()
            }
          } catch (error) {
            this.loading = false
          }
        } else {
          console.log(obj)
          for (const key in obj) {
            this.$message({
              type: 'warning',
              message: obj[key][0].message
            })
            return false
          }
          console.log('error submit!!')
          return false
        }
      })
    },
    async submit() {
      // 先执行保存
      await this.submitForm('form', true, async() => {
        // await this.getData();
        // 在执行提交
        submit(this.form.id).then((response) => {
          const flowId = response.data.flowId
          this.$message.success('提交成功')
          this.form.flowId = flowId
          this.getData()
        })
      })
    },
    popoverHide(value) {
      this.item.parent = value
    },
    handleAreaSelect(val, obj) {
      this.$refs.form.validateField('customerAreaId')
    }
  }
}
</script>

<style scoped></style>
